// An account can't have two exhibitors with the same name, ignoring case (the database's
// name_unique_exhibitor_idx). These let the add-exhibitor forms select the one already
// there instead of posting a duplicate that the API rejects.

const nameKey = name => String(name || '').trim().toLowerCase()

// The saved exhibitor in `list` with this name, or undefined. Unsaved entries (no id,
// e.g. the account owner offered as a new exhibitor) don't count.
export function findSavedExhibitorByName (list, firstName, lastName) {
  return (list || []).find(e => e && e.exhibitor_id &&
    nameKey(e.first_name) === nameKey(firstName) && nameKey(e.last_name) === nameKey(lastName))
}

// The API's 400 for a create that hit that index.
export function isDuplicateExhibitorError (err) {
  const error = err && err.response && err.response.data && err.response.data.error
  return !!error && error.constraint === 'name_unique_exhibitor_idx'
}
